import React from 'react';
import { Box } from '@mui/material';
import Header from '../../components/Header';
import HeroSection from '../../components/home/HeroSection';
import StatisticsSection from '../../components/home/StatisticsSection';
import ProblemSection from '../../components/home/ProblemSection';
import FeaturesSection from '../../components/home/FeaturesSection';
import UseCasesSection from '../../components/home/UseCasesSection';
import TrustedBySection from '../../components/home/TrustedBySection';
import PricingSection from '../../components/home/PricingSection';
import CTASection from '../../components/home/CTASection';
import Footer from '../../components/Footer';

const Home = () => {
    return (
        <Box sx={{ bgcolor: 'white', minHeight: '100vh' }}>
            <Header />
            <HeroSection />
            <StatisticsSection />
            <ProblemSection />
            <FeaturesSection />
            <UseCasesSection />
            <TrustedBySection />
            <PricingSection />
            <CTASection />
            <Footer />
        </Box>
    );
};

export default Home;